import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconShirtAdd';
/** Renders an SVG icon. */
const SvgShirtAdd = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path fill="currentColor" fillRule="evenodd" d="M21 24a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M24 21a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1M11.758 4.03A1 1 0 0 1 12 4h8a1 1 0 0 1 .242.03l2.12.53a8 8 0 0 1 3.716 2.104l3.63 3.629A1 1 0 0 1 29.8 11.6l-3 4a1 1 0 0 1-1.4.2L23 14v1a1 1 0 1 1-2 0v-3a1 1 0 0 1 1.6-.8l3.2 2.4 1.88-2.506-3.016-3.016A6 6 0 0 0 21.876 6.5l-1.34-.335-.747 1.493a4.236 4.236 0 0 1-7.578 0l-.747-1.493-1.34.335a6 6 0 0 0-2.788 1.578L4.32 11.094 6.2 13.6l3.2-2.4a1 1 0 0 1 1.6.8v13a1 1 0 0 0 1 1h2a1 1 0 1 1 0 2h-2a3 3 0 0 1-3-3V14l-2.4 1.8a1 1 0 0 1-1.4-.2l-3-4a1 1 0 0 1 .093-1.307l3.629-3.63A8 8 0 0 1 9.638 4.56zM13.617 6l.382.764a2.236 2.236 0 0 0 4 0L18.382 6h-4.764Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M24 29a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0 2a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
      />
    </svg>
  );
};
SvgShirtAdd.displayName = displayName;
export default SvgShirtAdd;
